module.exports = __webpack_public_path__ + "static/flight_soldout-a8759f04379d2334cec24dbd092d607f.svg";